module.exports = __webpack_public_path__ + "media/promo/lum2021/images/congr-m-55178f1657cf4f1d11845220f6aa5dfa.jpg";